import { useRef } from "react";
import FacebookLogin from "@greatsumini/react-facebook-login";
import { connect } from "react-redux";
import { Button } from "@components/core";
import { signIn } from "@actions/auth-actions";
import { authTypes } from '@utils/constants/authTypes';

const Facebook = ({
  // eslint-disable-next-line no-shadow
  signIn, authSuccess, authError,
}) => {
  const fbCredentials = useRef(null);

  async function onFacebookResponse(fbProfile) {
    const fbResponse = {
      ...fbCredentials.current,
      ...fbProfile,
    };

    try {
      const res = await signIn({ fb_response: fbResponse });
      authSuccess(res.user, authTypes.facebook);
    } catch (err) {
      authError(err, authTypes.facebook);
    }
  }

  return (
    <div className="flex-grow-1">
      <FacebookLogin
        appId={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
        fields="name,email,picture"
        scope="public_profile,email"
        returnScopes
        onSuccess={(response) => {
          fbCredentials.current = response;
        }}
        onFail={() => {
          fbCredentials.current = null;
        }}
        onProfileSuccess={(response) => {
          onFacebookResponse(response);
        }}
        render={({ onClick }) => (
          <Button
            variant="dark"
            fullWidth
            leftIconName="facebook"
            onClick={onClick}
            className="facebook-btn"
          />
        )}
      />
    </div>
  );
};

export default connect(null, { signIn })(Facebook);
